module.exports = __webpack_public_path__ + "img/footer_logo_novo.1dcf39a2.png";